/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {Account} from '@ion/core/src/types/entities';
import {editGroup} from './state';

interface SaveSSOAccountOptions {
  account: Account;
  refreshInitialization: Function;
  onUpdated: Function;
}

/**
 * Updates the account after its SSO Configuration was saved, then runs
 * `onUpdated` only when the account update succeeded.
 *
 * ```typescript
 *
 *  import {saveSSOAccount} from './saveSSOAccount';
 *  ...
 *
 *  saveSSOAccount(dispatch, {account, refreshInitialization, onUpdated});
 *
 * ```
 *
 * @param dispatch                      The Redux dispatch function.
 * @param options.account               The account carrying the new SSO fields.
 * @param options.refreshInitialization Refreshes the admin groups after the update.
 * @param options.onUpdated             Runs after the account update succeeded.
 */
export const saveSSOAccount = async(
  dispatch: Function,
  {account, refreshInitialization, onUpdated}: SaveSSOAccountOptions
): Promise<void> => {
  const isUpdated = await dispatch(editGroup(account, true, refreshInitialization));
  if (isUpdated) {
    onUpdated();
  }
};
